import React, { useEffect } from 'react';
import { StyleSheet, View, ActivityIndicator, Text } from 'react-native';
import { useDispatch } from 'react-redux';
import { checkAuthStatus } from '../../store/slices/authSlice';

const SplashScreen = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        console.log('SplashScreen: Iniciando verificación de autenticación');

        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Timeout')), 8000)
        );

        await Promise.race([
          dispatch(checkAuthStatus()).unwrap(),
          timeoutPromise
        ]);

        console.log('SplashScreen: Verificación completada');
      } catch (error) {
        console.log('SplashScreen: Error o timeout:', error.message);
        // Si hay timeout de red, checkAuthStatus ya manejará el fallback al cache.
        // El token real expira en el backend (1h) — esa es la seguridad.
      }
    };

    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color="#1e3c72" style={styles.spinner} />
      <Text style={styles.loadingText}>Iniciando sesión…</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1e3c72',
  },
  spinner: {
    marginBottom: 16,
  },
  loadingText: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.6)',
    fontWeight: '500',
  },
});

export default SplashScreen;